/* eslint-disable default-param-last */
/**
 * @description Reducer sobre as funções relacionadas aos exames do usuário
 * @author Diego Sabino Amorim de Araújo
 * @file meusExamesReducer.js
 *
 * @license Copyright (c) 2021 SIGEP DIGETI ITEP/RN
 */

import types from 'utils/actionTypes'

const initialState = {
  meusExamesEmAndamento: [],
  meusExamesFinalizados: [],
}

const meusExamesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_EXAMES_EM_ANDAMENTO: {
      return {
        ...state,
        meusExamesEmAndamento: action.examesEmAndamento,
      }
    }
    case types.FETCH_EXAMES_FINALIZADOS: {
      return {
        ...state,
        meusExamesFinalizados: action.examesFinalizados,
      }
    }

    default: {
      return state
    }
  }
}

export default meusExamesReducer
